import React from 'react'
import { SvgIcon } from '@mui/material'

export function ContactsOffIcon() {
  return (
    <SvgIcon
      viewBox="0 0 64 64"
      sx={{ color: 'error.main', width: '64px', height: '64px' }}
    >
      <path
        fill="#E6494F"
        fillRule="evenodd"
        d="M3.829 4.92 1.155 7.592 5.463 11.9c-.086.47-.13.95-.13 1.433v37.334a8 8 0 0 0 8 8h37.334c.483 0 .963-.044 1.432-.13l4.682 4.682 3.728-3.728L3.83 4.919Zm6.838 45.747V17.104L22.432 28.87a9.946 9.946 0 0 0 2.235 3.877A15.84 15.84 0 0 0 16 45.04a2.683 2.683 0 1 0 5.333.587A10.666 10.666 0 0 1 30 36.438l16.895 16.895H13.333a2.667 2.667 0 0 1-2.666-2.666Z"
        clipRule="evenodd"
      />
      <path
        fill="#E6494F"
        d="M58.667 50.313v-36.98a8 8 0 0 0-8-8H13.333a8 8 0 0 0-1.278.103l5.433 5.23h33.179a2.667 2.667 0 0 1 2.666 2.667v31.845l5.334 5.135Z"
      />
      <path
        fill="#E6494F"
        d="M43.759 35.96c-.352-.374-.723-.73-1.109-1.067l1.109 1.067ZM39.917 32.261a9.947 9.947 0 0 0 2.243-6.181 10.08 10.08 0 0 0-16.625-7.666l3.848 3.706a4.747 4.747 0 0 1 6.674 6.425l3.86 3.716Z"
      />
    </SvgIcon>
  )
}
